import { IconButton } from '@mui/material'
import { UploadArea, UploadTextArea, UploadText } from './ContainerImagesEditModalFileUpload.styles'
import UploadFileIcon from '@mui/icons-material/UploadFile'

export const ContainerImagesEditModalFileUploadMaximum: React.FC<{ labelText: string }> = ({
  labelText,
}): JSX.Element => (
  <UploadArea sx={{ background: '#F7F7F7' }}>
    <IconButton
      disabled
      aria-label="upload picture"
      sx={{ width: '70px', height: '70px', marginBottom: '8px' }}
    >
      <UploadFileIcon sx={{ width: '64px', height: '64px', color: '#D4D4D4' }} />
    </IconButton>
    <UploadTextArea>
      <UploadText sx={{ color: '#D4D4D4' }} variant={'body1'}>
        {labelText}&nbsp;
      </UploadText>
    </UploadTextArea>
  </UploadArea>
)
